module.exports = __webpack_public_path__ + "img/medicalapp_colour.35a1c536.webp";